import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/** Supplies the protocol title for /treatment-protocols/:id while the layout breadcrumb renders. */
@Injectable({ providedIn: 'root' })
export class TreatmentProtocolDetailBreadcrumbService {
    private readonly _label$ = new BehaviorSubject<string | null>(null);

    readonly label$ = this._label$.asObservable();

    setLabel(label: string | null): void {
        this._label$.next(label);
    }

    getLabel(): string | null {
        return this._label$.value;
    }
}
